import React from 'react'
import { Form } from '@s4l/ds'
import { IconTrash } from '@s4l/icons/IconTrash'
import { useS4LContext } from '@s4l/react-context'
import { withErrorBoundary } from '@s4l/utils/hocs/withErrorBoundary'

const FilterRatings = () => {
  const { i18n } = useS4LContext()

  const availableRatings = [9, 8, 7, 6] as const

  const ratingMessages = {
    9: i18n.formatMessage({ id: 'score.range-1' }),
    8: i18n.formatMessage({ id: 'score.range-2' }),
    7: i18n.formatMessage({ id: 'score.range-3' }),
    6: i18n.formatMessage({ id: 'score.range-4' }),
  } as const

  return (
    <Form.Fieldset>
      <Form.Legend>{i18n.formatMessage({ id: 'global.guest-rating' })}</Form.Legend>
      <Form.ClearButton icon={<IconTrash />}>
        {i18n.formatMessage({ id: 'serp.filter-clear' })}
      </Form.ClearButton>
      {availableRatings.map(rating => {
        return (
          <Form.Label key={`rating-${rating}`}>
            {ratingMessages[rating]}
            {`: ${rating}+`}
            <Form.Checkbox name="ratings" multiple trueValue={rating} />
          </Form.Label>
        )
      })}
    </Form.Fieldset>
  )
}

FilterRatings.displayName = 'SearchFilters.FilterRatings'
export default withErrorBoundary(FilterRatings)
